import { apiProvider } from './api';
import { NAME } from './constants';
import { router } from './router';
import SelectInput from './components/SelectInput.vue';
import Select from './components/Select.vue';

export const SkladoveMistoPneu = {
	name: NAME,
	apiProvider,
	router,
	components: {
		Select,
		SelectInput,
	},
};
